import React, { ErrorInfo, ReactNode } from 'react';
import { logger } from 'src/utils';
import { Logs } from 'src/constants/metrics';
import { CustomEditor } from 'src/types/CustomSlateTypes';
import { withError } from '../ErrorBoundary';

/**
* Slate can be difficult to debug from just default error info alone.
* So this ErrorBoundary will provide more context to the current state
* of the editor when the error occurs
 */
type EditorErrorBoundaryProps = {
  children: ReactNode;
  handleError: Function
  editor: CustomEditor,
};

class EditorErrorBoundary extends React.Component<EditorErrorBoundaryProps> {
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { handleError, editor } = this.props;
    const { children, history, selection } = editor;
    const logContext = {
      errorInfo,
      href: window.location.href,
      editorInfo: { children, history, selection },
    };
    logger.error(Logs.richTextEditorFailure, error, logContext)
      // After logging the error, display the app level error page
      .then(() => { handleError(); });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default withError(EditorErrorBoundary);
